import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    Divider,
    InputAdornment
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from "react";
import { urlRegex } from '../../constant';


const StepsConfiguration = ({ close, onSave, productSteps }) => {
    const [steps, setSteps] = useState(productSteps);
    const [errors, setErrors] = useState({});

    const handleChange = (index, field, value) => {
        const updated = [...steps];
        updated[index][field] = value;
        setSteps(updated);

        setErrors((prev) => ({
            ...prev,
            [index]: { ...prev[index], [field]: '' },
        }));
    };

    const handleDelete = (index) => {
        const updated = steps.filter((_, i) => i !== index);
        setSteps(updated);

        const newErrors = { ...errors };
        delete newErrors[index];
        setErrors(newErrors);
    };

    const handleAddStep = () => {
        setSteps([...steps, { title: '', url: '', description: '' }]);
    };

    const validateSteps = () => {
        const newErrors = {};
        steps.forEach((step, index) => {
            const stepErrors = {};
            if (!step.title.trim()) stepErrors.title = 'Title is required';
            if (!step.url.trim()) stepErrors.url = 'URL is required';
            else if (!urlRegex.test(step.url.trim()))
                stepErrors.url = 'Enter a valid URL (e.g., example.com)';
            if (!step.description.trim()) stepErrors.description = 'Description is required';
            if (Object.keys(stepErrors).length) newErrors[index] = stepErrors;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateSteps()) return;
        onSave(steps);
        close(false);
    };

    return (
        <Dialog fullWidth maxWidth="lg" open>
            <DialogTitle id="alert-dialog-title">Add Steps</DialogTitle>
            <DialogContent>
                {steps.map((step, index) => (
                    <Box key={index} className="border rounded p-3 mb-3">
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography variant="subtitle1" className="fw-semibold">
                                Step {index + 1}
                            </Typography>
                            <IconButton onClick={() => handleDelete(index)} size="small">
                                <DeleteIcon />
                            </IconButton>
                        </Box>

                        <Box className="row mb-2">
                            <div className="col-md-4">
                                <TextField
                                    fullWidth
                                    label="Title"
                                    value={step.title}
                                    onChange={(e) => handleChange(index, 'title', e.target.value)}
                                    error={!!errors[index]?.title}
                                    helperText={errors[index]?.title}
                                />
                            </div>
                            <div className="col-md-8">
                                <TextField
                                    fullWidth
                                    label="URL"
                                    value={step.url}
                                    onChange={(e) => handleChange(index, 'url', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography color="textSecondary">https://</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    error={!!errors[index]?.url}
                                    helperText={errors[index]?.url}
                                />
                            </div>
                        </Box>

                        <TextField
                            fullWidth
                            label="Description"
                            multiline
                            minRows={2}
                            value={step.description}
                            onChange={(e) => handleChange(index, 'description', e.target.value)}
                            error={!!errors[index]?.description}
                            helperText={errors[index]?.description}
                        />
                    </Box>
                ))}

                <Button color="primary" onClick={handleAddStep}>
                    + Add Step
                </Button>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="outlined" onClick={() => close(false)}>Close</Button>
                <Button variant="contained" onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default StepsConfiguration;
